"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addDaysToNow = exports.takeDaysFromNow = void 0;
const takeDaysFromNow = function () {
  let days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Date(new Date().getTime() - days * 24 * 60 * 60 * 1000);
};
exports.takeDaysFromNow = takeDaysFromNow;
const addDaysToNow = function () {
  let days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  return new Date(new Date().getTime() + days * 24 * 60 * 60 * 1000);
};
exports.addDaysToNow = addDaysToNow;